import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Movie, Showtime } from '../models';
import { API_BASE, params } from './api';

@Injectable({ providedIn: 'root' })
export class MovieService {
  constructor(private readonly http: HttpClient) {}

  list(filters: { query?: string; county?: string; date?: string; language?: string } = {}) {
    return this.http.get<Movie[]>(`${API_BASE}/movies${params(filters)}`);
  }

  get(id: string) {
    return this.http.get<Movie>(`${API_BASE}/movies/${id}`);
  }

  showtimes(id: string, filters: { county?: string; date?: string } = {}) {
    return this.http.get<Showtime[]>(`${API_BASE}/movies/${id}/showtimes${params(filters)}`);
  }
}
